import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import GestionResenasIA from "@/pages/servicios/GestionResenasIA";


export const Route = createFileRoute("/servicios/gestion-resenas-ia")({
  head: () => ({
    meta: [
      { title: "Gestión de Reseñas con IA | Reputación Online | SEOEVOLUTION" },
      { name: "description", content: "Tu reputación online decide si un cliente te elige a ti o a tu competencia. IA que consigue más reseñas 5⭐, responde automáticamente y mejora tu posicionamiento local. Diagnóstico personalizado." },
      { name: "keywords", content: "gestión de reseñas, reseñas Google, reputación online, valoraciones positivas, SEO local" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/gestion-resenas-ia" },
      { property: "og:title", content: "Gestión de Reseñas con IA | Reputación Online | SEOEVOLUTION" },
      { property: "og:description", content: "IA que consigue más reseñas 5⭐, responde automáticamente y mejora tu posicionamiento local." },
      { name: "twitter:title", content: "Gestión de Reseñas con IA | Reputación Online | SEOEVOLUTION" },
      { name: "twitter:description", content: "IA que consigue más reseñas 5⭐, responde automáticamente y mejora tu posicionamiento local." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/gestion-resenas-ia" }],
    scripts: serviceSchemaScripts("gestion-resenas-ia"),
  }),
  component: GestionResenasIA,
});
